<template>
  <div>
    <v-row class="mb-5">
      <v-col
        cols="12"
        sm="6"
        md="4"
      >
        <v-card>
          <v-card-text class="d-flex align-center justify-space-between pa-4">
            <div>
              <h2 class="font-weight-semibold mb-1">
                {{ total.length }}
              </h2>
              <span>Total</span>
            </div>

            <v-avatar :class="`v-avatar-light-bg primary--text`">
              <v-icon
                size="25"
                class="rounded-0"
                color="primary"
              >
                {{ icons.mdiAccountOutline }}
              </v-icon>
            </v-avatar>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col
        cols="12"
        sm="6"
        md="4"
      >
        <v-card>
          <v-card-text class="d-flex align-center justify-space-between pa-4">
            <div>
              <h2 class="font-weight-semibold mb-1">
                {{ total.length - ativos.length }}
              </h2>
              <span>Inativos</span>
            </div>

            <v-avatar :class="`v-avatar-light-bg primary--text`">
              <v-icon
                size="25"
                class="rounded-0"
                color="primary"
              >
                {{ icons.mdiAccountMultipleMinusOutline }}
              </v-icon>
            </v-avatar>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col
        cols="12"
        sm="6"
        md="4"
      >
        <v-card>
          <v-card-text class="d-flex align-center justify-space-between pa-4">
            <div>
              <h2 class="font-weight-semibold mb-1">
                {{ ativos.length }}
              </h2>
              <span>Ativos</span>
            </div>

            <v-avatar :class="`v-avatar-light-bg success--text`">
              <v-icon
                size="25"
                class="rounded-0"
                color="success"
              >
                {{ icons.mdiAccountCheckOutline }}
              </v-icon>
            </v-avatar>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>

import {
  mdiAccountCheckOutline, mdiAccountOutline, mdiAccountPlusOutline, mdiAccountRemoveOutline, mdiAccountMultipleMinusOutline,
} from '@mdi/js'

export default {
  props: {
    total: {
      type: Array,
      default: () => {},
    },
    ativos: {
      type: Array,
      default: () => {},
    },
  },

  data: () => ({
    icons: {
      mdiAccountPlusOutline,
      mdiAccountCheckOutline,
      mdiAccountRemoveOutline,
      mdiAccountOutline,
      mdiAccountMultipleMinusOutline,
    },

  }),

  methods: {
  },

}
</script>
